module.exports = __webpack_public_path__ + "static/media/poster_wide_s1.a341d7cd.png";